import { IUserProfile } from '../../pages/UsersPage/constants'
import { INewVictim } from '../questions/types'

export type DISPOSITION_TYPE = 'SUBSTANTIATED' | 'UNSUBSTANTIATED' | 'INCONCLUSIVE' | 'OTHER' | ''

export interface OUTCOME_DATA_TYPE {
  id: string,
  text: string,
  uuid: string,
}

export interface RESOLVED_DATA_TYPE {
  description?: string
  outcomes?: OUTCOME_DATA_TYPE[]
  uploadedFiles?: File[]
  file?: File
  report?: number
  disposition?: DISPOSITION_TYPE
}

export interface IReportsState {
  requiresTriage: IReport[]
  immediateAttention: IReport[]
  additionalInformationRequired: IReport[]
  addressedAndResolved: IReport[]
  addressedAndResolvedLoading: any
  assignedToMeForTriage: IReport[]
  acceptedReports: IReport[]
  openedCase?: IReport
  reportAnswers?: IBackendAnswer[]
  caseTypeQuestions: ICasetypeQuestions[]
  loading: boolean
  requiresTriageLoading: boolean
  userCasesLoading: boolean
  caseIsOpening: boolean
  caseTypeQuestionAnswers: MainObject[]
  defaultCaseTypeQuestionAnswers: MainObject[]
  answersToUpdate: string[]
  victimAnswers: { victimId: number; answers: MainObject[] }[]
  numberOfChanges: number,
  victims: INewVictim[]
}

export interface IWorkplace {
  work_site?: string
  work_zip_code?: string
  specific_worksite?: string
  work_city?: string
  work_state?: string
  work_country?: string
}

export interface IReport {
  id: number
  report_status: any
  survey: any
  workplace: any
  reporters: any
  victims: any
  subjects: any
  triage_level: any
  answers: any
  uuid: string
  name: string
  unique_code: string
  case_number: string
  tier_level: number
  created_at: string
  updated_at: string
  teamMembers: IUserProfile[]
  types: ICaseTypeDTO[]
  summary: string
  attorney: string
  resolvedData?: RESOLVED_DATA_TYPE
}

export interface ICaseTypeDTO {
  id: number
  text: string
  uuid: string
  subtypes: any[]
}

export interface IQuestion {
  title: string
  answers: IAnswers[]
}

export interface IAnswers {
  title: string
  subQuestions: IQuestion[]
}

export interface IValues {
  label: string
  value: string
}

export interface IAnswer {
  question_option: {
    text: string
    id: number
    variant?: {
      id: number
      type: string
      label: string
    }
  }
}

export interface IQuestionV2 {
  variant: {
    type: string
    label: string
  }
  label: string
  text: string
  text_third: string
  is_root: boolean
  uuid: string
  id: number
  options: { id: number; text: string }[]
  subquestions: ISubQuestion[]
  placeholder?: string
  option?: number
}

export interface ISubQuestion {
  variant: {
    type: string
    label: string
  }
  label: string
  text: string
  text_third: string
  is_root: boolean
  uuid: string
  option: number
  id: number
  options: { id: number; text: string }[]
  subquestions: ISubQuestion[]
}

export interface ISubanswers {
  variant: {
    type: string
    label: string
  }
  text: string
  is_root: boolean
  option: number
  question: IQuestionV2
}

export interface IBackendAnswer {
  answers: IAnswer[]
  question: IQuestionV2
  subanswers: ISubanswers[]
  uuid: string
  text: string
  victim: any
  subject: any
}

export interface ICasetypeQuestions {
  caseType: string
  questions: IQuestionV2[]
}

export interface ICasetypeAnswers {
  type: string
  answers: IBackendAnswer[]
}

export enum triageLevelStates {
  IMMEDIATE_ATTENTION_REQUIRED = 'IMMEDIATE_ATTENTION_REQUIRED',
  ADDITIONAL_INFORMATION_REQUIRED = 'ADDITIONAL_INFORMATION_REQUIRED',
  ADDRESSED_AND_RESOLVED = 'ADDRESSED_AND_RESOLVED',
  TRANSFERED_FOR_ASSIGNMENT = 'TRANSFERED_FOR_ASSIGNMENT',
  ACCEPTED_AND_ASSIGNED = 'ACCEPTED_AND_ASSIGNED',
  UNDER_INVESTIGATION = 'UNDER_INVESTIGATION',
  RESOLVE_AND_ARCHIVE = 'RESOLVE_AND_ARCHIVE',
}

export interface IReportDTO {
  id: number
  investigator: number
  message: string
  report: IReport
  uuid: string
}

export interface SubAnswer {
  id?: number
  answer: {
    question?: number | null
    text: string
    files?: number[]
  }
  victim?: any

  reporting_party?: any
  option: number
  options: any[]
  subanswers: any[]
  uuid: string
  caseType: string
  text: string
}

export interface MainObject {
  id?: number
  text: string
  answer: {
    question?: number | null
    text: string
    files?: number[]
    victim?: number
  }
  victim?: any
  reporting_party?: any
  options: any[]
  subanswers: SubAnswer[] 
  uuid: string
  caseType: string
}
